import { render, staticRenderFns } from "./delivery-owner.vue?vue&type=template&id=dc7a1550&scoped=true&"
import script from "./delivery-owner.vue?vue&type=script&lang=js&"
export * from "./delivery-owner.vue?vue&type=script&lang=js&"
import style0 from "./delivery-owner.vue?vue&type=style&index=0&id=dc7a1550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7a1550",
  null
  
)

component.options.__file = "delivery-owner.vue"
export default component.exports